// Copyright (c) Docugami, Inc. All rights reserved.

import { InfoView } from "components/work_path/InfoView";
import styled from "styled-components";
import emptyDocSetsUrl from "assets/EmptyDocSet.png";

const Container = styled.div`
    width: 100%;
    height: 100%;
    background: #FFFFFFBF;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
`

const AssigningImage = styled.img`
    width: 350px;
`
export const EmptyDocSetsCoachmark = (): JSX.Element => {
    const text = "To get started you'll need to upload some docs or assign some of your existing docs to doc sets."
    const subtext = "In the left-hand navigation bar, go to ADD DOCS to upload docs or to UNASSIGNED DOCS to assign docs you've already uploaded to doc sets."
    return (
        <Container>
            <InfoView
                icon={<AssigningImage src={emptyDocSetsUrl} />}
                titleText={text}
                secondaryText={[subtext]} />
        </Container>
    );
}
